<template>
  <b-modal v-model="model" @update:model-value="model = false">
    <template #header>
      <div class="px-10 pt-10 pb-2">
          <h1 class="mb-5">{{ title }}</h1>
      </div>
    </template>
    <template #default>
      <div class="px-10 mb-5">
        <div class="flex flex-col gap-5">
          <component :is="isComponent" v-model="formValue" :data-e2e="props.component === 'textarea' ? 'modal-info-textarea' : 'modal-info-input'" />
        </div>
      </div>
    </template>
    <template #footer>
      <div class="px-10 pb-10 pt-2 flex gap-4">
        <b-button
            @click="model = false"
            id="next_mission_cancel"
            block
            light
        >
          Annuler
        </b-button>
        <b-button
            @click="onSubmit"
            id="next_mission_submit"
            :loading="props.loading"
            block
            data-e2e="modal-info-save-button"
        >
            Sauvegarder
        </b-button>
      </div>
      </template>
  </b-modal>
</template>

<script lang="ts" setup>
import BTextarea from '~/components/forms/BTextarea.vue';
import BTextField from '~/components/forms/BTextField.vue';
import BModal from '../BModal.vue';
import BButton from '~/components/forms/BButton.vue';

interface Props {
    title: string;
    loading?: boolean;
    component?: 'textarea' | 'text-field'
}

const props = withDefaults(defineProps<Props>(), {
    component: 'text-field'
})
const model = defineModel();
const formValue = defineModel('formValue')
const emit = defineEmits(['submit'])

const components = {
    'text-field': BTextField,
    'textarea': BTextarea
}

const isComponent = computed(() => {
    return components[props.component]
})

const onSubmit = () => {
    emit('submit')
}
</script>